import React from "react";
import { colors } from "../../../../../shared/constants";
import { concatUrl } from "../../../helpers";
import MenuBadge from "./../../../../Header/DesktopMenu/DesktopMenuDrawers/MenuBadge";
import * as S from "./../../styles";
export default function TelehealthContent(_ref) {
  var e = _ref.topLevelLinks,
      t = _ref.telehealthCategories,
      a = _ref.scheduleVirtualCareVisit,
      l = _ref.renderLinkAs,
      r = _ref.handleLinkClick,
      n = _ref.root;
  return React.createElement(React.Fragment, null, e.telehealth && React.createElement(S.LinkCategory, null, React.createElement(S.LinkCategoryHeading, {
    "data-testid": "mobile-telehealth-heading"
  }, e.telehealth.label), React.createElement(S.MenuItem, {
    href: concatUrl(a.url, n),
    "data-testid": "mobile-telehealth-link",
    key: a.label,
    as: l || void 0,
    onClick: function onClick() {
      return r(a.mixpanelLabel);
    }
  }, a.label)), React.createElement(S.LinksWrapper, null, React.createElement(S.LinkCategoryHeading, {
    "data-testid": "mobile-telehealth-what-we-treat-heading"
  }, "What We Treat"), t.map(function (e, t) {
    return e.isEnabled ? React.createElement(S.MenuItem, {
      href: e.url,
      "data-testid": "mobile-telehealth-what-we-treat-link-".concat(t),
      key: e.displayName,
      as: l || void 0,
      onClick: function onClick() {
        return r(e.mixpanelLabel);
      }
    }, e.displayName, e.badge ? React.createElement(MenuBadge, {
      text: e.badge,
      backgroundColor: colors.teal4
    }) : null) : null;
  })));
}